import { render } from "./index.vue?vue&type=template&id=1a676bf6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1a676bf6&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=1a676bf6&lang=less"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_48ac5cde7c36a6fbb3736f36e5a55bfb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a676bf6"]])

export default __exports__